import uniqBy from 'lodash/uniqBy';

import type {SchedulerEventActions} from 'src/action-creators/scheduler/events';
import type {Events, ScheduledEvent} from 'src/types/scheduler/events';

import {
  SET_PAST_EVENTS,
  SET_PAST_EVENTS_FILTERS,
  APPEND_PAST_EVENTS,
  SET_UPCOMING_EVENTS,
  APPEND_UPCOMING_EVENTS,
  SET_UPCOMING_EVENTS_FILTERS,
  ADD_NEW_UPCOMING_EVENT,
  DELETE_UPCOMING_EVENT,
  UPDATE_EVENTS_STATUS,
} from 'src/action-creators/scheduler/events';

// other tools to be imported

const initialPastFilters = {
  page: '1',
  limit: '10',
  sortOrder: 'desc',
  title: '',
  distributionRules: '',
} as const;
const initialUpcomingFilters = {
  page: '1',
  limit: '10',
  sortOrder: 'asc',
  title: '',
  distributionRules: '',
} as const;

const initialEventData = {
  upcoming: {
    data: [],
    totalPages: 0,
    filters: initialUpcomingFilters,
  },
  past: {
    data: [],
    totalPages: 0,
    filters: initialPastFilters,
  },
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly upcoming: { readonly data: readonly []; readonly totalPages: 0; readonly filters: { readonly page: "1"; readonly limit: "10"; readonly sortOrder: "asc"; readonly title: ""; readonly distributionRules: ""; }; }; readonly past: { ...; }; }' is not assignable to type 'Events'.
  state: Events | null | undefined = initialEventData,
  action: SchedulerEventActions,
): Events => {
  switch (action.type) {
    case SET_PAST_EVENTS:
      // @ts-expect-error - TS2322 - Type '{ past: { data: ScheduledEvents; totalPages: number; filters: Filters; }; upcoming?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        past: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.past,
          data: action.payload.data,
          totalPages: action.payload.totalPages,
        },
      };
    case APPEND_PAST_EVENTS:
      // @ts-expect-error - TS2322 - Type '{ past: { data: ScheduledEvent[]; totalPages: number; filters: Filters; }; upcoming?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        past: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.past,
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          data: [...state.past.data, ...action.payload.data],
          totalPages: action.payload.totalPages,
        },
      };
    case SET_PAST_EVENTS_FILTERS:
      // @ts-expect-error - TS2322 - Type '{ past: { filters: Filters; data: ScheduledEvents; totalPages: number; }; upcoming?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        past: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.past,
          filters: action.payload,
        },
      };
    case SET_UPCOMING_EVENTS:
      // @ts-expect-error - TS2322 - Type '{ upcoming: { data: ScheduledEvents; totalPages: number; filters: Filters; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          data: action.payload.data,
          totalPages: action.payload.totalPages,
        },
      };
    case APPEND_UPCOMING_EVENTS:
      // @ts-expect-error - TS2322 - Type '{ upcoming: { data: ScheduledEvent[]; totalPages: number; filters: Filters; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          data: uniqueEvents([...state.upcoming.data, ...action.payload.data]),
          totalPages: action.payload.totalPages,
        },
      };
    case SET_UPCOMING_EVENTS_FILTERS:
      // @ts-expect-error - TS2322 - Type '{ upcoming: { filters: Filters; data: ScheduledEvents; totalPages: number; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          filters: action.payload,
        },
      };
    case ADD_NEW_UPCOMING_EVENT:
      const sortedUpcomingEventsData = [
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        ...state.upcoming.data,
        action.payload,
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
      ].sort((a, b) => new Date(a.eventStart) - new Date(b.eventStart));
      // @ts-expect-error - TS2322 - Type '{ upcoming: { data: ScheduledEvent[]; totalPages: number; filters: Filters; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          data: uniqueEvents(sortedUpcomingEventsData),
        },
      };
    case DELETE_UPCOMING_EVENT:
      // @ts-expect-error - TS2322 - Type '{ upcoming: { data: ScheduledEvent[]; totalPages: number; filters: Filters; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          data: state.upcoming.data.filter(
            (event) => event.id !== action.payload,
          ),
        },
      };
    case UPDATE_EVENTS_STATUS:
      // @ts-expect-error - TS2322 - Type '{ upcoming: { data: ScheduledEvent[]; totalPages: number; filters: Filters; }; past?: Event | undefined; }' is not assignable to type 'Events'.
      return {
        ...state,
        upcoming: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.upcoming,
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          data: state.upcoming.data.map((event) => {
            const eventsObject = action.payload || {};
            if (action.payload[event.id]) {
              const {key, value} = eventsObject[event.id];
              return {...event, [key]: value};
            }
            return event;
          }),
        },
      };
    default:
      // @ts-expect-error - TS2322 - Type 'Events | null' is not assignable to type 'Events'.
      return state;
  }
};

const uniqueEvents = (events: ScheduledEvent[]): ScheduledEvent[] => {
  return uniqBy(events, 'id');
};
